"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importScripts = exports.removeWidget = exports.setDepartment = void 0;
var WIDGET_BASE_PATH = 'https://widget.nuvidio.com';
// const WIDGET_BASE_PATH = 'https://hmlwidget.nuvidio.com'
var nuvidio = {
    loaded: false,
    _c: []
};
var methods = ['init'];
methods.forEach(function (methodName) {
    nuvidio[methodName] = function () {
        nuvidio._c.push([methodName, arguments]);
    };
});
function __addScripts(container) {
    var urls = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        urls[_i - 1] = arguments[_i];
    }
    urls.forEach(function (u) {
        var n = document.createElement('script');
        if (typeof u === 'string')
            n.src = u;
        else {
            n.src = u.url;
        }
        n.type = 'text/javascript';
        if (typeof u === 'object' && u.callback) {
            n.onload = u.callback;
        }
        container.appendChild(n);
    });
}
function importScripts() {
    var container = document.getElementById('nuvidio-widget');
    if (!container) {
        container = document.createElement('div');
        container.id = 'nuvidio-widget';
        document.body.appendChild(container);
    }
    if (!document.getElementById('nuvidio-widget-container')) {
        var c = document.createElement('div');
        c.id = 'nuvidio-widget-container';
        container.appendChild(c);
    }
    __addScripts(container, {
        url: WIDGET_BASE_PATH + "/js/nuvidio-widget.min.js",
        callback: function () {
            nuvidio.loaded = true;
            nuvidio._c.forEach(function (f) {
                var _a;
                switch (f[0]) {
                    case 'init':
                        (_a = window.NuVidio).init.apply(_a, f[1]);
                }
            });
            nuvidio._c = [];
        }
    });
}
exports.importScripts = importScripts;
function setDepartment(identifier, options) {
    if (nuvidio.loaded) {
        if (window.NuVidio) {
            window.NuVidio.init(identifier, options);
        }
        else {
            throw new Error('Error to load NuVidio Widget');
        }
    }
    else {
        nuvidio.init(identifier, options);
    }
}
exports.setDepartment = setDepartment;
function removeWidget() {
    var i = document.getElementById('nuvidio-widget');
    if (i) {
        i.remove();
    }
}
exports.removeWidget = removeWidget;
